import { useEffect } from "react";
import { act } from "../net/rally.ts";

const EVERY = 20_000;

function looking(): void {
  if (typeof document !== "undefined" && document.visibilityState !== "visible") return;

  void act("push.looking", {}).catch(() => undefined);
}

export function Looking(): null {
  useLooking();
  return null;
}

export function useLooking(): void {
  useEffect(() => {
    looking();
    const beat = setInterval(looking, EVERY);

    const woke = () => looking();
    document.addEventListener("visibilitychange", woke);
    return () => {
      clearInterval(beat);
      document.removeEventListener("visibilitychange", woke);
    };
  }, []);
}
